import "./LayoutNavSide.css";
import React from "react";
import SideBar from "./SideBar/SideBar";
import { Outlet } from "react-router-dom";
import NavBar from "../../Component/Navbar/NavBar";


function LayoutNavSide() {
  return (
    <div className="layout-nav-side position-relative ">
      <NavBar/>
      <div className="d-flex ">
        <SideBar />
        <div className="lNS-droit pt-3">
          <Outlet />
        </div>
      </div>
    
    </div>
  );
};

export default LayoutNavSide


